import "./public/webawesome";
import "./utils/mrujs-and-cablecar";
import { ensureDeclarativeOpenModalDialogsAreModal } from "./vendor/@practical-computer/practical-views/util/ensure-delcarative-open-modal-dialogs-are-modal";

document.addEventListener(
  `DOMContentLoaded`,
  ensureDeclarativeOpenModalDialogsAreModal,
);

import "./public/elements";

import "@mux/mux-player";
import "@zachleat/table-saw";
